<template>
  <div>
    <Navbar />
    <div
      class="h-screen bg-cover bg-center lg:bg-right flex items-center bg-[url(https://dcctsvhz4yusz.cloudfront.net/d3a2584c-7488-4654-ae6e-e84ea3f8041c.jpg)] lg:bg-[url(https://dcctsvhz4yusz.cloudfront.net/462bcef5-ced3-485f-ba76-9254dbddfadc.jpg)]">
      <div class="standard-spacing flex flex-col justify-center h-full">
        <div class="h-3/4 flex items-center">
          <div class="heading-1 mt-16">Welcome to the evolution of workplace wellbeing & performance.</div>
        </div>
        <div class="flex flex-col justify-center h-1/4">
          <HoapButton label="Let's Begin" inverted class="mx-auto" @click="goToContent" />
          <HoapIcon icon="ArrowDown" class="h-12 md:h-24 lg:h-36 animate-bounce mt-8 md:mt-16 mx-auto" />
        </div>
      </div>
    </div>
    <div ref="content" class="bg-gradient-green">
      <div class="standard-spacing standard-spacing-y">
        <h2 class="heading-1 text-center">Our approach</h2>
        <p class="heading-3 text-center mt-16">We drive performance through a culture of wellbeing.</p>
        <p class="subheading mt-16 text-center">
          Our approach has been tried and tested by <span class="font-decorative">high performance</span> organisations
          around the world.
        </p>
        <p class="subheading mt-8 text-center">
          We <span class="font-decorative">elevate</span> teams with evidence-based knowledge and a focus on technology
          and education.
        </p>
        <p class="subheading mt-8 text-center">
          We're also at the forefront of innovative research so we not only keep up with best practices, but
          <span class="font-decorative">discover</span>
          them too.
        </p>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-x-8 md:gap-x-24 lg:gap-x-48 mt-16 text-center">
          <HowHoapWorksColumn
            title="Technology"
            :paragraphs="[
              'We are the industry leaders in monitoring personal and team wellbeing.',
              'Our smart technology enables your organisation to know how your talent are really feeling from month to month, giving you the opportunity to make meaningful change at the time it is needed.',
            ]" />
          <HowHoapWorksColumn
            title="Education"
            :paragraphs="[
              'We ensure your talent and leaders are equipped with the skills they need to drive personal and team wellbeing.',
              'Our tools and resources, original expert content and multiple training options means your organisation always has access to an appropriate level of education.',
            ]"
            class="mt-8 md:mt-0" />
          <HowHoapWorksColumn
            title="Partnership"
            :paragraphs="[
              `We partner with your organisation to embed wellbeing into your culture.`,
              `We form part of your organisation's ecosystem and work with you to optimise initiatives and offerings that you already have in place.`,
            ]"
            class="mt-8 md:mt-0" />
        </div>
        <HowHoapWorks class="standard-spacing-t" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { Ref } from 'vue'

  import HowHoapWorks from '~~/layoutComponents/HowHoapWorks.vue'

  const content: Ref<HTMLElement | null> = ref(null)

  const goToContent = () => {
    if (content.value) {
      window.scrollTo({ top: content.value.offsetTop, behavior: 'smooth' })
    }
  }
  setMetadata({ pageTitle: 'How Hoap Works', imageUrl: '/img/how-hoap-works/header.png' })
</script>
